import { render, staticRenderFns } from "./FeesAndChargeFormModal.vue?vue&type=template&id=09c8375a"
import script from "./FeesAndChargeFormModal.vue?vue&type=script&lang=js"
export * from "./FeesAndChargeFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports